"use strict";

exports.__esModule = true;
exports.AlertDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _Translator = require("../../Core/Translator");
var _AppNavbar = require("../../App/AppNavbar");
var _useAlertDetailsController = require("./useAlertDetailsController");
var _AlertDetailsViewMode = require("./AlertDetailsViewMode");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AlertDetails = exports.AlertDetails = (0, _reactRouterCompat.withRouter)(function AlertDetailsWithRouterProp(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var width = props.width,
    height = props.height,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
  var _useAlertDetailsContr = (0, _useAlertDetailsController.useAlertDetailsController)(props),
    isLoading = _useAlertDetailsContr.isLoading,
    data = _useAlertDetailsContr.data,
    error = _useAlertDetailsContr.error,
    handleCreateComment = _useAlertDetailsContr.handleCreateComment,
    handleClose = _useAlertDetailsContr.handleClose,
    refreshAlertData = _useAlertDetailsContr.refreshAlertData,
    handleAcknowledged = _useAlertDetailsContr.handleAcknowledged;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
  }
  var alertDetails = data[0];
  if (error || !alertDetails) {
    var fetchError = error || new Error("Alert Not Found");
    return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: fetchError,
      title: translate("AlertDetails.fetchError", "Unable to fetch Alert Details")
    });
  }
  var getDetailsViewContent = function getDetailsViewContent() {
    return /*#__PURE__*/_react["default"].createElement(_AlertDetailsViewMode.AlertDetailsViewMode, {
      height: height,
      width: width,
      alertDetails: alertDetails,
      createAlertComment: handleCreateComment,
      onClose: handleClose,
      refreshData: refreshAlertData,
      isFullScreen: isFullScreen,
      handleAcknowledged: handleAcknowledged
    });
  };
  if (isFullScreen) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("NewAlertDetailsScreen.title", "Alert Details"),
      "data-testid": "NewAlertDetails"
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
      title: translate("AlertDetailsScreen.navbar.title", "Alert Details")
    }), getDetailsViewContent()));
  }
  return /*#__PURE__*/_react["default"].createElement(_Core.DetailsWrapper, {
    "data-testid": "NewAlertDetails",
    isFullScreen: isFullScreen,
    width: width,
    height: height
  }, getDetailsViewContent());
});